import { Outlet, Link } from "react-router-dom";
import { ShieldCheck, Zap, BarChart3, Users } from "lucide-react";

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-slate-50 flex">
      {/* Left Panel */}
      <div className="hidden lg:flex lg:w-1/2 xl:w-5/12 bg-slate-900 flex-col justify-between p-12 text-white relative overflow-hidden">
        {/* Ambient gradients */}
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-indigo-600/15 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-emerald-600/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4" />

        <div className="relative z-10">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="h-10 w-10 bg-indigo-500 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-500/25 group-hover:shadow-indigo-500/40 transition-shadow">
              <ShieldCheck className="h-6 w-6 text-white" />
            </div>
            <span className="text-2xl font-bold tracking-tight">Korvry</span>
          </Link>
        </div>

        <div className="relative z-10 space-y-10">
          <div>
            <h1 className="text-4xl xl:text-5xl font-bold leading-[1.15]">
              Recover debts
              <br />
              <span className="text-indigo-400">smarter.</span>
            </h1>
            <p className="mt-5 text-lg text-slate-300 leading-relaxed max-w-sm">
              The modern debt recovery platform built for real estate, schools,
              and microfinance organizations.
            </p>
          </div>

          <div className="space-y-6">
            {[
              {
                icon: Zap,
                color: "text-indigo-400",
                bg: "bg-indigo-500/10",
                title: "Automated Workflows",
                desc: "Set up recovery campaigns that run on autopilot with smart triggers.",
              },
              {
                icon: BarChart3,
                color: "text-emerald-400",
                bg: "bg-emerald-500/10",
                title: "Real-time Analytics",
                desc: "Track recovery rates, team performance, and revenue in real time.",
              },
              {
                icon: Users,
                color: "text-amber-400",
                bg: "bg-amber-500/10",
                title: "Team Collaboration",
                desc: "Invite members with role-based access control and activity tracking.",
              },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-4">
                <div
                  className={`h-11 w-11 rounded-xl ${item.bg} flex items-center justify-center shrink-0`}
                >
                  <item.icon className={`h-5 w-5 ${item.color}`} />
                </div>
                <div>
                  <h3 className="font-semibold text-white text-sm">
                    {item.title}
                  </h3>
                  <p className="text-sm text-slate-400 mt-1 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative z-10 text-sm text-slate-600">
          © {new Date().getFullYear()} Korvry Technologies. All rights reserved.
        </div>
      </div>

      {/* Right Panel */}
      <div className="flex-1 flex flex-col justify-center items-center p-4 sm:p-8 lg:p-12 overflow-y-auto">
        <div className="w-full max-w-md py-8">
          <div className="lg:hidden flex items-center justify-center gap-3 mb-12">
            <div className="h-10 w-10 bg-indigo-600 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-600/20">
              <ShieldCheck className="h-6 w-6 text-white" />
            </div>
            <span className="text-2xl font-bold text-slate-900">Korvry</span>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
